<template>
    <Dialog :dialog="dlg">
        <v-form ref="form" lazy-validation>
            <Form>

                <FormRow col-label="6" label="Kostprijs per uur">
                    <NumberField amount :model="model" :rules="model.rules.amount_intern" v-model="model.amount_intern"></NumberField>
                </FormRow>
                <FormRow col-label="6" label="Te factureren uurtarief">
                    <NumberField amount :model="model" :rules="model.rules.amount_extern" v-model="model.amount_extern"></NumberField>
                </FormRow>

            </Form>
        </v-form>        
    </Dialog>
</template>



<script setup>
    import useModel from '@/models/employeetariff'
    import Form from '@controls/forms/Form'
    import FormColumn from '@controls/forms/FormColumn'
    import FormRow from '@controls/forms/FormRow'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import NumberField from '@controls/input/NumberField'

    const form = ref(null);

    let model = useModel();
    let dlg = ref(
        new clsDialog("employee_tariff", "Tarief", model, [form], {
        } )).value;

</script>
